module.exports = __webpack_public_path__ + "img/xqnm.3e4c7ed7.jpg";